import { render, staticRenderFns } from "./MyExercises.vue?vue&type=template&id=3045c72e"
import script from "./MyExercises.vue?vue&type=script&lang=js"
export * from "./MyExercises.vue?vue&type=script&lang=js"
import style0 from "./MyExercises.vue?vue&type=style&index=0&id=3045c72e&prod&lang=css"
import style1 from "./MyExercises.vue?vue&type=style&index=1&id=3045c72e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports